import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconBranchCommit = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M7 2.25C5.48122 2.25 4.25 3.48122 4.25 5c0 1.25878.84575 2.32002 2 2.64648v8.70702c-1.15425.3265-2 1.3877-2 2.6465 0 1.5188 1.23122 2.75 2.75 2.75S9.75 20.5188 9.75 19c0-1.2588-.84575-2.32-2-2.6465v-2.4034c0-.6903.55964-1.25 1.25-1.25h6c1.5188 0 2.75-1.2312 2.75-2.74995V7.64648c1.1543-.32646 2-1.3877 2-2.64648 0-1.51878-1.2312-2.75-2.75-2.75S14.25 3.48122 14.25 5c0 1.25878.8457 2.32002 2 2.64648v2.30367c0 .69035-.5596 1.24995-1.25 1.24995H9c-.45011 0-.87497.1082-1.25.2999V7.64648c1.15425-.32646 2-1.3877 2-2.64648 0-1.51878-1.23122-2.75-2.75-2.75ZM5.75 5c0-.69036.55964-1.25 1.25-1.25S8.25 4.30964 8.25 5 7.69036 6.25 7 6.25 5.75 5.69036 5.75 5Zm10 0c0-.69036.5596-1.25 1.25-1.25s1.25.55964 1.25 1.25-.5596 1.25-1.25 1.25-1.25-.55964-1.25-1.25ZM7 17.75c-.69036 0-1.25.5596-1.25 1.25s.55964 1.25 1.25 1.25 1.25-.5596 1.25-1.25-.55964-1.25-1.25-1.25Z",
		clipRule: "evenodd"
	})
});
export { SvgIconBranchCommit as ReactComponent };
